// Canonical public site origin for SEO absolute URLs (canonical, OG, Twitter, JSON-LD).
// Hardcoded to the production domain so metadata is correct even while testing
// on the Emergent preview URL. Override via REACT_APP_SITE_URL if ever needed.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://explora.mu').replace(/\/$/, '');
